import { ProviderComment, renderDate } from '@enter/core';
import Markdown from 'markdown-to-jsx';
import React from 'react';
import { getNickname, isHtmlContent, sanitizeHtml } from '@enter/core/src/ui/messaging/util';
import * as S from './claim-timeline-table.styles';

interface ICommentDetailProps {
    comment: ProviderComment;
}

export const CommentDetail: React.FunctionComponent<ICommentDetailProps> = (
    props: ICommentDetailProps
): React.ReactElement => {
    const { comment } = props;

    const renderCommentBody = (): React.ReactElement => {
        if (!comment.body) {
            return <></>;
        }

        const isHtml = isHtmlContent(comment.body);
        
        return (
            <S.CommentBodyContainer>
                {isHtml ? (
                    <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(comment.body) }} />
                ) : (
                    <Markdown>{comment.body}</Markdown>
                )}
            </S.CommentBodyContainer>
        );
    };

    return (
        <S.ExpandWrap key={comment.id}>
            <S.ExpandCol>
                <S.ExpandTable expand={true}>
                    <S.ExpandTBody>
                        <S.ExpandTR>
                            <S.ExpandTH>Comment ID</S.ExpandTH>
                            <S.ExpandTD>{comment.id}</S.ExpandTD>
                        </S.ExpandTR>
                        <S.ExpandTR>
                            <S.ExpandTH>Author</S.ExpandTH>
                            <S.ExpandTD>{getNickname(comment.author)}</S.ExpandTD>
                        </S.ExpandTR>
                        <S.ExpandTR>
                            <S.ExpandTH>Created Date</S.ExpandTH>
                            <S.ExpandTD>{renderDate(comment.created)}</S.ExpandTD>
                        </S.ExpandTR>
                        {comment.body && (
                            <S.ExpandTR>
                                <S.ExpandTH>Body</S.ExpandTH>
                                <S.ExpandTDCommentBody>
                                    {renderCommentBody()}
                                </S.ExpandTDCommentBody>
                            </S.ExpandTR>
                        )}
                    </S.ExpandTBody>
                </S.ExpandTable>
            </S.ExpandCol>
        </S.ExpandWrap>
    );
};

